import { Component, OnChanges, OnInit, OnDestroy, AfterViewInit, AfterViewChecked } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { GridOptionsModel, ColumnDefinitionsModel, PaginationsModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { SignupSetupService } from './shared/providers/signup-setup.service';
import { Router } from '@angular/router';
import { BreadCrumbModel, StepIndicatorModel, StepIndicatorService, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components';
import { BREADCRUMBS, STEPINDICATORS } from 'config';


@Component({
  selector: 'app-signup-setup',
  templateUrl: './signup-setup.component.html',
  styleUrls: ['./signup-setup.component.scss'],
  providers: [StepIndicatorService, SignupSetupService]
})

export class SignupSetupComponent implements OnInit, OnDestroy {
  stepIndicators: StepIndicatorModel[];
  displayFlag: boolean;
  sessionName: string;
  emmProductCode: any;
  currentStep: any;
  prodcode: string;
  isNewABmFlow: boolean = false;

  constructor(private stepindicatorService: StepIndicatorService,
    private breadCrumbService: BreadCrumbService,
    private signupSetupService: SignupSetupService) {
      this.isNewABmFlow = sessionStorage.getItem('newABMFlow') ? JSON.parse(sessionStorage.getItem('newABMFlow')) : false;

  }

  ngOnInit() {
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Device Enrollment Program', routerLink: '/signupsetup/enrollmentoptions' });
    // this.emmProductCode = this.signupService.getSelectedProdCode();
    //this.emmProductCode = JSON.parse(this.signupSetupService.getSelectedProdCode()).emmProductCode;
    // this.emmProductCode = sessionStorage.getItem('emmProductCode');
    this.prodcode = sessionStorage.getItem('prodcode');

    if (this.emmProductCode === 'DMPSKME' || this.emmProductCode === 'DMPGZTP' || this.emmProductCode === 'DMPAABM') {
      this.sessionName = 'signUpAll';
      this.stepIndicators = STEPINDICATORS.signUpAll;

    } else {
      this.sessionName = 'signupAll';
      this.stepIndicators = STEPINDICATORS.signUpAll;
    }
    if (this.stepindicatorService.getSteps(this.sessionName) === null) {
      this.stepindicatorService.setSteps(this.stepIndicators, this.sessionName);
    }
    this.stepIndicators = this.stepindicatorService.getSteps(this.sessionName);
    this.stepindicatorService.getVisibility().subscribe(
      (status: boolean) => {
        this.displayFlag = status;
      }
    );

    this.stepindicatorService.getCurrentStep().subscribe(
      (path: string) => {
        this.currentStep = path +' step';
      });
  }

  ngOnDestroy() {
    this.signupSetupService.removeSignupModel();
    sessionStorage.removeItem('SignupBacktoCallingPage');
    sessionStorage.removeItem('backupProfiles');
    sessionStorage.removeItem('ProfileSize');
  }
}
